import React from 'react';
import Snackbar from 'components/DesignSystem/Snackbar';
import './index.scss';

export interface CustomAlert {
  title: string,
  message: string,
  variant: string,
}

export default function AlertsCollection({ alerts }: { alerts: CustomAlert[] }) {
  return (
    <div className="mx-5">
      {alerts.map(({ title, message, variant }) => (
        <Snackbar
          className="mb-2"
          key={`${title}-${message}`}
          variant={variant}
        >
          {title && (
            <div className="mb-1"><b>{title}</b></div>
          )}
          <div>{message}</div>
        </Snackbar>
      ))}
    </div>
  );
}
